import { render, staticRenderFns } from "./language.vue?vue&type=template&id=72942e97&scoped=true"
import script from "./language.vue?vue&type=script&lang=js"
export * from "./language.vue?vue&type=script&lang=js"
import style0 from "./language.vue?vue&type=style&index=0&id=72942e97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72942e97",
  null
  
)

export default component.exports